export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8992.a19d6488.jpg";